import styled from 'styled-components';
import { DollarOutlined } from '@ant-design/icons';

export const DollarIcon = styled(DollarOutlined)`
  font-size: 12px;
  color: #fff;
`;
